import { useToast } from '@/shared/lib/toast';

interface CopyOptions {
  successMessage?: string;
  errorMessage?: string;
}

const DEFAULT_SUCCESS = 'Ссылка скопирована';
const DEFAULT_ERROR = 'Не удалось скопировать ссылку';

export function useCopyToClipboard() {
  const toast = useToast();

  const copy = async (text: string, options: CopyOptions = {}): Promise<boolean> => {
    try {
      await navigator.clipboard.writeText(text);
      toast.show(options.successMessage ?? DEFAULT_SUCCESS);
      return true;
    } catch {
      toast.error(options.errorMessage ?? DEFAULT_ERROR);
      return false;
    }
  };

  return { copy };
}
